import * as React from 'react';
import { FormGroup, ControlLabel, FormControl } from 'react-bootstrap';
import { Translate } from '../../../../../shared/LanguageService';
import FormSelect from '../../../../../components/common/FormSelect';
import { IProduct } from '../Types';

interface IProps {
    onChange: (e: any) => void;
    products: IProduct[];
    product: number;
}

const ProductSelect = (props: IProps) => {
    return (
        <FormGroup className="product-select">
            <ControlLabel>
                {Translate('view-order/basic-order-info/products/selector/label')}
            </ControlLabel>
            <FormSelect
                name="product"
                value={props.product as any}
                onChange={props.onChange}
                defaultTranslateKey="view-order/basic-order-info/products/selector/placeholder"
            >
                {props.products.map((r: IProduct) => { 
                    return ( 
                        r.name != r.standardProductName ? 
                            <option key={r.id} value={r.id as any}>
                                {r.name} ({r.standardProductName})
                            </option> 
                            : 
                            <option key={r.id} value={r.id as any}>
                                {r.name} 
                            </option>
                    )})
                }
            </FormSelect>
        </FormGroup>
    );
};

export default ProductSelect;
